<template>
    <div class="saas-page people-page linear-command-page sip-list-page">
        <div class="saas-hero card-saas people-page__hero sip-list-head">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('user.user') }}</span>
                </p>
                <h1 class="saas-hero__title">{{trans('user.user')}}</h1>
            </div>
            <div class="people-page__actions">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" aria-controls="user-filter-panel" :aria-expanded="showFilterPanel ? 'true' : 'false'" @click.prevent="showFilterPanel = !showFilterPanel">
                    <admin-icon name="sliders" aria-hidden="true"></admin-icon><span>{{trans('general.filter')}}</span>
                </button>
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" v-if="hasPermission('create-user')" v-b-modal.modal-1>
                    <admin-icon name="plus" aria-hidden="true"></admin-icon><span>{{trans('user.create_user')}}</span>
                </button>
            </div>
        </div>

        <div class="people-command-grid sip-kpi-strip">
            <section class="people-command-card sip-kpi">
                <span class="people-command-card__label">{{ trans('user.user') }}</span>
                <strong>{{ users.total || 0 }}</strong>
                <p>{{ users.total ? trans('general.total_result_found',{'count' : users.total}) : trans('user.module_info_description') }}</p>
            </section>
            <section class="people-command-card people-command-card--muted sip-kpi">
                <span class="people-command-card__label">{{ trans('general.filter') }}</span>
                <strong>{{ appliedFilterCount }}</strong>
                <p>{{ appliedFilterHint }}</p>
            </section>
            <section class="people-command-card people-command-card--muted sip-kpi">
                <span class="people-command-card__label">{{ trans('general.sort_by') }}</span>
                <strong>{{ sortLabel }}</strong>
                <p>{{ orderLabel }} · {{ filterUserForm.page_length }} {{ trans('general.per_page') }}</p>
            </section>
        </div>

        <transition name="fade">
            <div id="user-filter-panel" class="card-saas people-filter-card mb-2" v-if="showFilterPanel">
                <div class="card-body">
                    <h4 class="card-saas__title">{{trans('general.filter')}}</h4>
                    <div class="row">
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('user.first_name')}}</label>
                            <input class="form-control" name="first_name" v-model="filterUserForm.first_name">
                        </div>
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('user.last_name')}}</label>
                            <input class="form-control" name="last_name" v-model="filterUserForm.last_name">
                        </div>
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('user.email')}}</label>
                            <input class="form-control" name="email" v-model="filterUserForm.email">
                        </div>
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('role.role')}}</label>
                            <select v-model="filterUserForm.role_id" class="custom-select col-12">
                                <option value="">{{trans('general.select_one')}}</option>
                                <option v-for="role in roles" v-bind:value="role.id">
                                {{ role.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('user.status')}}</label>
                            <select v-model="filterUserForm.status" class="custom-select col-12">
                                <option value="">{{trans('general.select_one')}}</option>
                                <option value="activated">{{trans('user.status_activated')}}</option>
                                <option value="pending_activation">{{trans('user.status_pending_activation')}}</option>
                                <option value="pending_approval">{{trans('user.status_pending_approval')}}</option>
                                <option value="banned">{{trans('user.status_banned')}}</option>
                                <option value="disapproved">{{trans('user.status_disapproved')}}</option>
                            </select>
                        </div>
                        <div class="col-6 col-md-6 form-group">
                            <date-range-picker :start-date.sync="filterUserForm.created_at_start_date" :end-date.sync="filterUserForm.created_at_end_date" :label="trans('user.created_at')"></date-range-picker>
                        </div>
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('general.sort_by')}}</label>
                            <select name="order" class="form-control" v-model="filterUserForm.sort_by">
                                <option value="first_name">{{trans('user.first_name')}}</option>
                                <option value="last_name">{{trans('user.last_name')}}</option>
                                <option value="email">{{trans('user.email')}}</option>
                                <option value="status">{{trans('user.status')}}</option>
                                <option value="created_at">{{trans('user.created_at')}}</option>
                            </select>
                        </div>
                        <div class="col-6 col-md-3 form-group">
                            <label for="">{{trans('general.order')}}</label>
                            <select name="order" class="form-control" v-model="filterUserForm.order">
                                <option value="asc">{{trans('general.ascending')}}</option>
                                <option value="desc">{{trans('general.descending')}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
               
        <div class="admin-list-table-card mt-2" v-if="hasPermission('list-user') && users.total">
            <div class="table-responsive">
                <table class="table admin-data-table mb-0">
                    <thead>
                        <tr>
                            <sortable-th field="first_name" :sort-by="filterUserForm.sort_by" :order="filterUserForm.order" @sort="sortUsers">{{trans('user.name')}}</sortable-th>
                            <sortable-th field="email" :sort-by="filterUserForm.sort_by" :order="filterUserForm.order" @sort="sortUsers">{{trans('user.email')}}</sortable-th>
                            <th>{{trans('role.role')}}</th>
                            <sortable-th field="status" :sort-by="filterUserForm.sort_by" :order="filterUserForm.order" @sort="sortUsers">{{trans('user.status')}}</sortable-th>
                            <sortable-th field="created_at" :sort-by="filterUserForm.sort_by" :order="filterUserForm.order" @sort="sortUsers">{{trans('user.created_at')}}</sortable-th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in users.data" :key="user.id">
                            <td>
                                <div class="people-table__identity">
                                    <img :src="getAvatar(user)" alt="" class="people-table__avatar">
                                    <div class="people-table__copy">
                                        <div class="people-table__primary" v-text="user.profile.first_name+' '+user.profile.last_name"></div>
                                        <span class="people-table__meta">#{{ user.id }}</span>
                                    </div>
                                </div>
                            </td>
                            <td><span class="people-table__email" v-text="user.email"></span></td>
                            <td>
                                <ul class="admin-table-role-list">
                                    <li v-for="role in user.roles" :key="role.id">{{role.name}}</li>
                                </ul>
                            </td>
                            <td>
                                <span
                                    v-for="status in getUserStatus(user)"
                                    :key="status.label"
                                    :class="['admin-status-badge', 'admin-status-badge--' + status.color, 'mr-1']"
                                >
                                    {{ status.label }}
                                </span>
                            </td>
                            <td><span class="people-table__date">{{user.created_at | moment}}</span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item :to="'/user/'+user.id">
                                        <admin-icon name="eye"></admin-icon> {{ trans('user.view_user') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('delete-user')"
                                        v-confirm="{ok: confirmDelete(user)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterUserForm.page_length" :records="users" @updateRecords="getUsers"></pagination-record>
            </div>
        </div>

        <div class="admin-list-table-card admin-empty-state mt-2" v-if="!users.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="users"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('user.module_info_title') }}</h4>
                <p class="admin-empty-state__text">{{ trans('user.module_info_description') }}</p>
                <button
                    v-if="hasPermission('create-user')"
                    type="button"
                    class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid mt-2"
                    v-b-modal.modal-1
                >
                    <admin-icon name="plus"></admin-icon> {{ trans('user.create_user') }}
                </button>
            </div>
        </div>

        <b-modal id="modal-1" hide-footer size="lg" centered modal-class="admin-modal-pro" content-class="admin-modal-pro__content">
            <template #modal-title>{{trans('user.add_new_user')}}</template>
            <form @submit.prevent="submit" @keydown="userForm.errors.clear($event.target.name)">
                <div class="row">
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.first_name')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.first_name" name="first_name" :placeholder="trans('user.first_name')">
                        <show-error :form-name="userForm" prop-name="first_name"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.last_name')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.last_name" name="last_name" :placeholder="trans('user.last_name')">
                        <show-error :form-name="userForm" prop-name="last_name"></show-error>
                    </div>
                    <div class="col-12 col-md-12 form-group">
                        <label for="">{{trans('user.email')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.email" name="email" :placeholder="trans('user.email')">
                        <show-error :form-name="userForm" prop-name="email"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.password')}}</label>
                        <input class="form-control" type="password" value="" v-model="userForm.password" name="password" :placeholder="trans('user.password')">
                        <show-error :form-name="userForm" prop-name="password"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.password_confirmation')}}</label>
                        <input class="form-control" type="password" value="" v-model="userForm.password_confirmation" name="password_confirmation" :placeholder="trans('user.password_confirmation')">
                        <show-error :form-name="userForm" prop-name="password_confirmation"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('role.role')}}</label>
                        <v-select label="name" track-by="id" v-model="selected_roles" name="role_id" id="role_id" :options="roles" :placeholder="trans('role.select_role')" @select="onRoleSelect" :multiple="true" :close-on-select="false" :clear-on-select="false" :hide-selected="true" @remove="onRoleRemove" :selected="selected_roles"></v-select>
                        <show-error :form-name="userForm" prop-name="role_id"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.address_line_1')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.address_line_1" name="address_line_1" :placeholder="trans('user.address_line_1')">
                        <show-error :form-name="userForm" prop-name="address_line_1"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.address_line_2')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.address_line_2" name="address_line_2" :placeholder="trans('user.address_line_2')">
                        <show-error :form-name="userForm" prop-name="address_line_2"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.city')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.city" name="city" :placeholder="trans('user.city')">
                        <show-error :form-name="userForm" prop-name="city"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.state')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.state" name="state" :placeholder="trans('user.state')">
                        <show-error :form-name="userForm" prop-name="state"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.zipcode')}}</label>
                        <input class="form-control" type="text" value="" v-model="userForm.zipcode" name="zipcode" :placeholder="trans('user.zipcode')">
                        <show-error :form-name="userForm" prop-name="zipcode"></show-error>
                    </div>
                    <div class="col-12 col-md-6 form-group">
                        <label for="">{{trans('user.country')}}</label>
                        <select class="form-control" name="country_id" v-model="userForm.country_id">
                            <option value="">{{trans('user.country')}}</option>
                            <option v-for="country in countries" :value="country.value">{{country.text}}</option>
                        </select>
                        <show-error :form-name="userForm" prop-name="country_id"></show-error>
                    </div>
                </div>
                <div class="admin-modal-pro__footer">
                    <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.add')}}</button>
                    <div class="admin-modal-pro__footer-extra">
                        <switches v-model="userForm.send_email" theme="bootstrap" color="success"></switches>
                        <span class="admin-modal-pro__switch-label">{{trans('user.send_welcome_email')}}</span>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>


<script>
    import switches from 'vue-switches'
    import vSelect from 'vue-multiselect'
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components: {switches,vSelect,dateRangePicker},
        data() {
            return {
                showCreatePanel: false,
                users: {
                    total: 0,
                    data: []
                },
                filterUserForm: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    role_id: '',
                    status: '',
                    created_at_start_date: '',
                    created_at_end_date: '',
                    sort_by : 'first_name',
                    order: 'asc',
                    page_length: helper.getConfig('page_length')
                },
                userForm: new Form({
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    role_id: [],
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zipcode: '',
                    country_id: '',
                    send_email: ''
                }),
                countries: [],
                roles: [],
                selected_roles: '',
                showFilterPanel: false
            };
        },
        computed: {
            appliedFilterCount(){
                const form = this.filterUserForm;
                let count = 0;
                if (form.first_name) count++;
                if (form.last_name) count++;
                if (form.email) count++;
                if (form.role_id) count++;
                if (form.status) count++;
                if (form.created_at_start_date || form.created_at_end_date) count++;
                return count;
            },
            appliedFilterHint(){
                if (this.appliedFilterCount) {
                    return this.trans('general.filter') + ': ' + this.appliedFilterCount;
                }
                if (this.users.from && this.users.to) {
                    return this.users.from + '–' + this.users.to;
                }
                return this.trans('general.sort_by') + ': ' + this.sortLabel;
            },
            sortLabel(){
                const labels = {
                    first_name: this.trans('user.first_name'),
                    last_name: this.trans('user.last_name'),
                    email: this.trans('user.email'),
                    status: this.trans('user.status'),
                    created_at: this.trans('user.created_at')
                };
                return labels[this.filterUserForm.sort_by] || this.filterUserForm.sort_by;
            },
            orderLabel(){
                return this.filterUserForm.order === 'asc'
                    ? this.trans('general.ascending')
                    : this.trans('general.descending');
            }
        },
        mounted(){
            if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.fetchPreRequisites();
            this.getUsers();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.countries = response.countries;
                        this.roles = response.roles;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            onRoleSelect(selectedOption){
                this.userForm.errors.clear('role_id');
                this.userForm.role_id.push(selectedOption.id);
            },
            onRoleRemove(removedOption){
                this.userForm.role_id.splice(this.userForm.role_id.indexOf(removedOption.id), 1);
            },
            submit(){
                this.userForm.post('/api/user')
                    .then(response => {
                        toastr.success(response.message);
                        this.selected_roles = null;
                        this.userForm.role_id = [];
                        this.getUsers();
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getUsers(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                this.$bvModal.hide("modal-1");
                let url = helper.getFilterURL(this.filterUserForm);
                axios.get('/api/user?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.users = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    })
            },
            sortUsers(field){
                if (this.filterUserForm.sort_by === field) {
                    this.filterUserForm.order = this.filterUserForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterUserForm.sort_by = field;
                    this.filterUserForm.order = 'asc';
                }
            },
            confirmDelete(user){
                return dialog => this.deleteUser(user);
            },
            deleteUser(user){
                axios.delete('/api/user/'+user.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getUsers();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getUserStatus(user){
                return helper.getUserStatus(user);
            },
            getAvatar(user){
                return helper.getAvatar(user);
            }
        },
        watch: {
            filterUserForm: {
                handler(val){
                    this.getUsers();
                },
                deep: true
            }
        },
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        }
    }
</script>

<style scoped>
.people-page__hero {
    align-items: center;
}

.people-page__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.5rem;
}

.people-command-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
    margin: 0.75rem 0 1rem;
}

.people-command-card {
    min-height: 0;
    padding: 0.75rem 1rem;
}

.people-command-card strong {
    display: block;
    margin-top: 0.2rem;
}

.people-command-card p {
    margin: 0.2rem 0 0;
    line-height: 1.4;
}

.people-filter-card {
    padding: 0;
    overflow: hidden;
}

.people-filter-card .card-body {
    padding: 1rem 1.15rem;
}

.people-table__identity {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    min-width: 0;
}

.people-table__avatar {
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 999px;
    object-fit: cover;
}

.people-table__copy {
    display: flex;
    flex-direction: column;
    gap: 0.05rem;
    min-width: 0;
    line-height: 1.25;
}

.people-table__primary {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.25;
}

.people-table__meta {
    display: block;
    margin-top: 0;
    font-size: 12px;
    line-height: 1.2;
}

@media (max-width: 575.98px) {
    .people-page__hero {
        align-items: flex-start;
    }

    .people-page__actions {
        justify-content: flex-start;
        width: 100%;
    }
}

@media (max-width: 991.98px) {
    .people-command-grid {
        grid-template-columns: 1fr;
    }
}
</style>
